import { render, staticRenderFns } from "./MainEventInfo.vue?vue&type=template&id=0afc8967&scoped=true&"
import script from "./MainEventInfo.vue?vue&type=script&lang=js&"
export * from "./MainEventInfo.vue?vue&type=script&lang=js&"
import style0 from "./MainEventInfo.vue?vue&type=style&index=0&id=0afc8967&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afc8967",
  null
  
)

export default component.exports